/**
 * EstimateItemWrapper
 *  wraps EstimateItem objects (which are just data) with rules which govern whether
 *  an explanation is required for the estimate item. When no rules are given a default
 *  rule of 'always return false' is used.
 **/
var EstimateItemWrapper = /** @class */ (function () {
    function EstimateItemWrapper(item) {
        var explanationRules = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            explanationRules[_i - 1] = arguments[_i];
        }
        this._explanationRules = [];
        this.item = item;
        if (explanationRules && explanationRules.length > 0) {
            this._explanationRules = explanationRules;
        }
        else {
            // No rules given, use default rule == do not require explanation for the estimate item
            this._explanationRules.push(function () { return false; });
        }
    }
    /**
     * If any of the rules returns true, then the wrapped estimate item requires an explanation
     * */
    EstimateItemWrapper.prototype.requireExplanation = function () {
        return this._explanationRules.some(function (rule) { return rule(); });
    };
    return EstimateItemWrapper;
}());
export default EstimateItemWrapper;
